import React, { useState, useEffect } from 'react';
import { Box, Typography, makeStyles, ListItem, IconButton } from '@material-ui/core';
import { useTranslate, useDataProvider, usePermissions } from 'react-admin';
import SelectBox from '../common/info-page/select-box';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import OneLineTextField from '../users/CustomTextField';
import SelectBoxFilter from '../common/select-box-filter'
import icAttachment from '../assets/icons/ic_attachment.png';
import { isImage, isVideo, FONT_SIZE_LABEL } from '../utils';
import DialogChooseFile from '../file-management/file-management-dialog';
import GreenSwitch from '../CustomizedUIs/GreenSwitch'
import { PrimaryButton } from '../common/button';
import { useSelector, useDispatch } from 'react-redux';
import { changeInfoPageDirtyStatus, changeNodeMainData } from '../redux/actions/tree-action';
import ThumbnailIcon from './thumbnail';
import { lightBlue, grey } from '@material-ui/core/colors';

const useStyles = makeStyles(() => ({
    borderCard: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        // opacity: 0.5,
        border: "solid 1px #c1e5fa",
        width: '600px',
        // height: '132px',
        marginTop: '18px'
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    boxBorder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    TitleSmall: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
    TitleSwitch: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '11px',
        letterSpacing: '0.36px',
        color: '#4f5064',
    },
    disabled: {
        cursor: 'pointer',
        borderBottomColor: grey['900'],
        pointerEvents: 'none',
        opacity: 0.4
    },
    enabled: {
        cursor: 'pointer',
        borderBottomColor: lightBlue['100']
    },
}));

const DATE_TIMES = [
    { key: 'dd/mm/yyyy', name: 'day/month/year' },
    { key: 'dd-mm-yyyy', name: 'day-month-year' },
    { key: 'dd.mm.yyyy', name: 'day.month.year' },
    { key: 'mm/dd/yyyy', name: 'month/day/year' },
    { key: 'mm-dd-yyyy', name: 'month-day-year' },
    { key: 'mm.dd.yyyy', name: 'month.day.year' },
    { key: 'yyyy/mm/dd', name: 'year/month/day' },
    { key: 'yyyy-mm-dd', name: 'year-month-day' },
    { key: 'yyyy.mm.dd', name: 'year.month.day' },
];

const ICON_TEXT_SIZE = [
    { id: 1, name: 'pos.common.icon_size.small', value: FONT_SIZE_LABEL.SMALL },
    { id: 2, name: 'pos.common.icon_size.medium', value: FONT_SIZE_LABEL.MEDIUM, },
    { id: 3, name: 'pos.common.icon_size.large', value: FONT_SIZE_LABEL.LARGE },
];

function getDateTimeValue(key) {
    const item = DATE_TIMES.find(item => item.key === key);
    if (item) {
        return item.name;
    } else {
        return '';
    }
}

function NodeMain() {
    const classes = useStyles();
    const translate = useTranslate();
    const { permissions, loaded } = usePermissions();
    const dispatch = useDispatch();
    const dataProvider = useDataProvider();

    const [openPoper, setOpenPopper] = useState(false);
    const [openDateTime, setOpenDateTime] = useState(false);
    const [openIcon, setOpenIcon] = useState(false);
    const [locations, setLocations] = useState([]);

    const { isEditing, nodeSelected, selectedInfoPage } = useSelector(state => state.tree);
    const {
        weather, rssLink, textSize, dyslexie, backgroundImage, logoType,
        instructionVideo, instructionFeatureImage, formatDateTime
    } = nodeSelected.data;

    const [openFilegImage, setOpenFilegImage] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    });

    const [openFileLogo, setOpenFileLogo] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    });

    const [openFileVideo, setOpenFileVideo] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    });
    const [openFileFeatured, setOpenFileFeatured] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    });

    const handleOpenFileDialog = (value) => {
        switch (value) {
            case 'image':
                setOpenFilegImage({
                    status: true,
                    defaultId: 4,
                    format: isImage,
                    setResponse: value => onChangeData({ backgroundImage: value })
                })
                break;
            case 'logo':
                setOpenFileLogo({
                    status: true,
                    defaultId: 4,
                    format: isImage,
                    setResponse: value => onChangeData({ logoType: value })
                })
                break;
            case 'video':
                setOpenFileVideo({
                    status: true,
                    defaultId: 6,
                    format: isVideo,
                    setResponse: value => onChangeData({ instructionVideo: value })
                })
                break;
            case 'featured':
                setOpenFileFeatured({
                    status: true,
                    defaultId: 4,
                    format: isImage,
                    setResponse: value => onChangeData({ instructionFeatureImage: value })
                })
                break;
            default:
                break;
        }
    }

    const handleClose = (value) => {
        switch (value) {
            case 'image':
                setOpenFilegImage({
                    status: false,
                    defaultId: 1,
                    format: '',
                    setResponse: null
                })
                break;
            case 'logo':
                setOpenFileLogo({
                    status: false,
                    defaultId: 1,
                    format: '',
                    setResponse: null
                })
                break;
            case 'video':
                setOpenFileVideo({
                    status: false,
                    defaultId: 1,
                    format: '',
                    setResponse: null
                })
                break;
            case 'featured':
                setOpenFileFeatured({
                    status: false,
                    defaultId: 1,
                    format: '',
                    setResponse: null
                })
                break;
            default:
                break;
        }
    }

    const onChangeDateTime = (value) => {
        setOpenDateTime(false);
        onChangeData({ formatDateTime: value });
    }

    const onChangeIconSize = (value) => {
        onChangeData({ textSize: value });
        setOpenIcon(false);
    }

    const onGetFontSizeLabel = () => {
        const sizeObj = ICON_TEXT_SIZE.find(item => item.value === textSize);
        if (sizeObj) {
            return translate(sizeObj.name);
        } else {
            return '';
        }
    }

    const onChangeData = (data, isDirty = true) => {
        const nodeMain = {
            id: nodeSelected.id,
            data: {
                ...nodeSelected.data,
                ...data,
            }
        };
        dispatch(changeNodeMainData(nodeMain));
        if (isDirty) {
            dispatch(changeInfoPageDirtyStatus(true));
        }
    }

    const getListLocation = () => {
        dataProvider('GET_LIST', 'location', {
            filter: {},
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'createdAt', order: 'DESC' },
        }).then(({ data }) => {
            setLocations(data);
        }).catch(error => console.error('@@@ getListLocation error:', error));
    }

    const getFile = () => {
        var requests = [];
        var backgroundImageFile = null
        var logoTypeFile = null
        var instructionVideoFile = null
        var instructionFeatureImageFile = null
        if (backgroundImage) {
            requests.push(dataProvider('GET_ONE', 'categories', {
                id: backgroundImage.id
            }).then(({ data }) => {
                if (data) {
                    backgroundImageFile = data
                }
            }).catch(error => {
                console.log('GET FILE ERROR:', error);
            }))
        }
        if (logoType) {
            requests.push(dataProvider('GET_ONE', 'categories', {
                id: logoType.id
            }).then(({ data }) => {
                if (data) {
                    logoTypeFile = data
                }
            }).catch(error => {
                console.log('GET FILE ERROR:', error);
            }));
        }
        if (instructionVideo) {
            requests.push(dataProvider('GET_ONE', 'categories', {
                id: instructionVideo.id
            }).then(({ data }) => {
                if (data) {
                    instructionVideoFile = data
                }
            }).catch(error => {
                console.log('GET FILE ERROR:', error);
            }));
        }
        if (instructionFeatureImage) {
            requests.push(dataProvider('GET_ONE', 'categories', {
                id: instructionFeatureImage.id
            }).then(({ data }) => {
                if (data) {
                    instructionFeatureImageFile = data
                }
            }).catch(error => {
                console.log('GET FILE ERROR:', error);
            }));
        }
        Promise.all(requests)
            .then(() => {
                const nodeMain = {
                    id: nodeSelected.id,
                    data: {
                        ...nodeSelected.data,
                        backgroundImage: backgroundImageFile,
                        logoType: logoTypeFile,
                        instructionVideo: instructionVideoFile,
                        instructionFeatureImage: instructionFeatureImageFile
                    }
                };
                dispatch(changeNodeMainData(nodeMain));
            })
            .catch(error => {
                console.log('error', error)
            })
    }

    useEffect(() => {
        getFile();
        getListLocation();
    }, []);

    if (!loaded) return null
    return (
        <Box>
            <Box mt={2}>
                <SelectBox
                    disabled={!isEditing}
                    label={translate('resources.infoPage.date_time')}
                    value={getDateTimeValue(formatDateTime)}
                    open={openDateTime}
                    handleClick={() => setOpenDateTime(!openDateTime)}
                >
                    <Box className={classes.boxBorder}>
                        {
                            DATE_TIMES.map((value) => (
                                <ListItem key={value.key} style={{ padding: '8px' }} button onClick={() => onChangeDateTime(value.key)}>
                                    <Typography className={classes.TexTSelect} >{value.name}</Typography>
                                </ListItem>
                            ))
                        }
                    </Box>
                </SelectBox>
            </Box>
            <Box mt={2}>
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate('resources.infoPage.rss')}
                    value={rssLink}
                    onChange={(e) => onChangeData({ rssLink: e.target.value })}
                    style={{ width: 600 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate(`pos.common.rss`)}
                        content={translate(`pos.common.contentRss`)}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box mt={2}>
                <SelectBoxFilter
                    disabled={!isEditing}
                    data={locations}
                    label={translate('resources.infoPage.weather')}
                    value={weather}
                    onChange={(value) => onChangeData({ weather: value.city })}
                    keyName='city'
                    placeholder={translate('resources.infoPage.filter_location')}
                />
            </Box>
            <Box mt={2}>
                <SelectBox
                    disabled={!isEditing}
                    label={translate('resources.infoPage.icon_text_size')}
                    value={onGetFontSizeLabel()}
                    open={openIcon}
                    handleClick={() => setOpenIcon(!openIcon)}
                >
                    <Box className={classes.boxBoder}>
                        {
                            ICON_TEXT_SIZE.map(item => (
                                <ListItem key={item.id.toString()} style={{ padding: '8px' }} button onClick={() => onChangeIconSize(item.value)}>
                                    <Typography className={classes.TexTSelect} >{translate(item.name)}</Typography>
                                </ListItem>
                            ))
                        }
                    </Box>
                </SelectBox>
            </Box>
            <hr style={{ marginTop: "30px", marginBottom: "30px", borderTopColor: '#f3f7fa' }} />
            <Box mt={2}>
                <Typography className={classes.TitleSmall}>{translate('pos.common.add')}</Typography>
            </Box>
            <Box className={classes.disabled}>
                <Box
                    className={classes.borderCard} justifyContent='center' alignItems="center" >
                    <Box display='flex' width="100%" alignItems="center">
                        <Box mx={2} display='flex' alignItems="center">
                            <IconButton
                                variant="outlined"
                                color='primary'
                                style={{ marginRight: '10px', padding: 'unset' }}
                            >
                                <img src={icAttachment} width={27} alt='' />
                            </IconButton>
                            <Typography style={{ marginRight: '20px' }} className={classes.TitleSmall}>{translate('pos.common.backgroundImage')}</Typography>
                            <CustomPoper
                                color={'#e5f1f8'}
                                fontSize={'8.8px'}
                                open={openPoper}
                                handleClick={() => setOpenPopper(true)}
                                handleClose={() => setOpenPopper(false)}
                                title={translate(`pos.common.backgroundImage`)}
                                content={translate(`resources.infoPage.contentBackgroundImage`)}
                                icon={<b>?</b>} />
                        </Box>
                        <Box style={{ marginLeft: 'auto' }} mx={2} my={2}>
                            <PrimaryButton disabled={!isEditing} label={!backgroundImage ? 'Browse' : 'Change'} onClick={() => handleOpenFileDialog('image')} />
                            <DialogChooseFile
                                formats={openFilegImage.format}
                                defaultId={openFilegImage.defaultId}
                                open={openFilegImage.status}
                                pickerMode='pickMediaOnly'
                                handleClose={() => handleClose('image')}
                                setChooseValue={openFilegImage.setResponse}
                                isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                            />
                        </Box>
                    </Box>
                    <ThumbnailIcon
                        thumbnail={backgroundImage}
                        onClear={() => onChangeData({ backgroundImage: null })}
                        isImage
                    />
                </Box>
            </Box>

            <Box className={classes.borderCard} justifyContent='center' alignItems="center" >
                <Box display='flex' width="100%" alignItems="center">
                    <Box mx={2} display='flex' alignItems="center">
                        <IconButton
                            variant="outlined"
                            color='primary'
                            style={{ marginRight: '10px', padding: 'unset' }}
                        >
                            <img src={icAttachment} width={27} alt='' />
                        </IconButton>
                        <Typography style={{ marginRight: '20px' }} className={classes.TitleSmall}>{translate('resources.infoPage.logotype')}</Typography>
                        <CustomPoper
                            color={'#e5f1f8'}
                            fontSize={'8.8px'}
                            open={openPoper}
                            handleClick={() => setOpenPopper(true)}
                            handleClose={() => setOpenPopper(false)}
                            title={translate(`resources.infoPage.logotype`)}
                            content={translate(`resources.infoPage.contentLogoType`)}
                            icon={<b>?</b>} />
                    </Box>
                    <Box style={{ marginLeft: 'auto' }} mx={2} my={2}>
                        <PrimaryButton disabled={!isEditing} label={!logoType ? translate('pos.common.browse') : translate('pos.common.change')} onClick={() => handleOpenFileDialog('logo')} />
                        <DialogChooseFile
                            formats={openFileLogo.format}
                            defaultId={openFileLogo.defaultId}
                            open={openFileLogo.status}
                            pickerMode='pickMediaOnly'
                            handleClose={() => handleClose('logo')}
                            setChooseValue={openFileLogo.setResponse}
                            isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                        />
                    </Box>
                </Box>
                <ThumbnailIcon
                    thumbnail={logoType}
                    onClear={() => onChangeData({ logoType: null })}
                    isImage
                />
            </Box>
            <Box mt={5}>
                <Typography className={classes.TitleSmall}>{translate('resources.infoPage.instructional_video')}</Typography>
            </Box>
            <Box className={classes.disabled}>
                <Box className={classes.borderCard} justifyContent='center' alignItems="center" >
                    <Box display='flex' width="100%" alignItems="center">
                        <Box mx={2} display='flex' alignItems="center">
                            <IconButton
                                variant="outlined"
                                color='primary'
                                style={{ marginRight: '10px', padding: 'unset' }}
                            >
                                <img src={icAttachment} width={27} alt='' />
                            </IconButton>
                            <Typography style={{ marginRight: '20px' }} className={classes.TitleSmall}>{translate('pos.common.video')}</Typography>
                            <CustomPoper
                                color={'#e5f1f8'}
                                fontSize={'8.8px'}
                                open={openPoper}
                                handleClick={() => setOpenPopper(true)}
                                handleClose={() => setOpenPopper(false)}
                                title={translate(`pos.common.video`)}
                                content={translate(`resources.infoPage.contentVideo`)}
                                icon={<b>?</b>} />
                        </Box>
                        <Box style={{ marginLeft: 'auto' }} mx={2} my={2}>
                            <PrimaryButton disabled={!isEditing} label={!instructionVideo ? translate('pos.common.browse') : translate('pos.common.change')} onClick={() => handleOpenFileDialog('video')} />
                            <DialogChooseFile
                                formats={openFileVideo.format}
                                defaultId={openFileVideo.defaultId}
                                open={openFileVideo.status}
                                pickerMode='pickMediaOnly'
                                handleClose={() => handleClose('video')}
                                setChooseValue={openFileVideo.setResponse}
                                isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                            />
                        </Box>
                    </Box>
                    <ThumbnailIcon thumbnail={instructionVideo} onClear={() => onChangeData({ instructionVideo: null })} />
                    <Box display='flex' width="100%" alignItems="center">
                        <Box mx={2} display='flex' alignItems="center">
                            <IconButton
                                variant="outlined"
                                color='primary'
                                style={{ marginRight: '10px', padding: 'unset' }}
                            >
                                <img src={icAttachment} width={27} alt='' />
                            </IconButton>
                            <Typography style={{ marginRight: '20px' }} className={classes.TitleSmall}>{translate('resources.infoPage.featured_image')}</Typography>
                            <CustomPoper
                                color={'#e5f1f8'}
                                fontSize={'8.8px'}
                                open={openPoper}
                                handleClick={() => setOpenPopper(true)}
                                handleClose={() => setOpenPopper(false)}
                                title={translate(`resources.infoPage.featured_image`)}
                                content={translate(`resources.infoPage.contentFeaturedImage`)}
                                icon={<b>?</b>} />
                        </Box>
                        <Box style={{ marginLeft: 'auto' }} mx={2} my={2}>
                            <PrimaryButton disabled={!isEditing} label={!instructionFeatureImage ? translate('pos.common.browse') : translate('pos.common.change')} onClick={() => handleOpenFileDialog('featured')} />
                            <DialogChooseFile
                                formats={openFileFeatured.format}
                                defaultId={openFileFeatured.defaultId}
                                open={openFileFeatured.status}
                                pickerMode='pickMediaOnly'
                                handleClose={() => handleClose('featured')}
                                setChooseValue={openFileFeatured.setResponse}
                                isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                            />
                        </Box>
                    </Box>
                    <ThumbnailIcon
                        thumbnail={instructionFeatureImage}
                        onClear={() => onChangeData({ instructionFeatureImage: null })}
                        isImage
                    />
                </Box>
            </Box>
            <Box my={1} width='173px' mt={2} style={{ marginLeft: 'auto', marginBottom: 20 }} >
                <Box display='flex' borderRadius={4} bgcolor='background.paper' my={1} px={1} alignItems='center'>
                    <Box flexGrow={1}>
                        <Typography className={classes.TitleSwitch} >{translate(`pos.messages.dyslexieFont`).toUpperCase()}</Typography>
                    </Box>
                    <GreenSwitch
                        disabled={!isEditing}
                        checked={dyslexie}
                        onChange={() => onChangeData({ dyslexie: !dyslexie })}
                        size='small'
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default NodeMain;
